


import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import Main from "../Main";
import { Alert } from "@mui/material";
import AppBreadcrumbs from "../../components/ui/AppBreadcrumbs";

import {
  getSingleMerchantStore,
  postSingleMerchant
} from "../../api/userAuth";

import { getLocation } from "../../components/Navigator/Navigator";
// import { showToastMessage } from "../../utils/toastUtils"; // ❌ Removed
import { useNotify } from "../../context/NotifyContext"; // ✅ Added
import { getPincodeDetails } from "../../utils/pincodeLookup";

const MerchantBusiness = () => {
  const {notify} = useNotify(); // ✅ Notification hook

  const { username } = useParams();
  // const { userInfo } = useSelector((state) => state?.auth);
  const { userInfo, location: savedLocation } = useSelector((s) => s.auth);
  const [form, setForm] = useState({
    storeName: "",
    businessType: "",
    address: "",
    city: "",
    district: "",
    state: "",
    pincode: "",
    latitude: "",
    longitude: ""
  });

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(""); // ✅ Error state for plan check
const  navigate  = useNavigate()
  /* ================= AUTH GUARD ================= */
  useEffect(() => {
    if (!userInfo) {
      notify("Please login first", "error");
      window.location.href = "/login";
      return;
    }
  }, [userInfo, notify]);

  /* ================= AUTO FILL & PLAN CHECK ================= */
  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await getSingleMerchantStore(username);
        if (res?.success) {
          const m = res.data;

          if (!m?.planId) {
            setError(
              "This user has not been assigned a plan. You cannot add a store. Please contact admin."
            );
          } else {
            setForm((prev) => ({
              ...prev,
              storeName: m.storeName || "",
              businessType: m.businessType || "",
              address: m.address || "",
              city: m.city || "",
              district: m.district || "",
              state: m.state || "",
              pincode: m.pincode || "",
              latitude: m.location?.coordinates?.[1] || "",
              longitude: m.location?.coordinates?.[0] || ""
            }));
          }
        } else {
          setError(
            res?.message ||
              "This user has not been assigned a plan. You cannot add a store. Please contact admin."
          );
        }
      } catch (err) {
        notify("Failed to fetch merchant profile", "error");
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, [username]);

  /* ================= AUTO LOCATION ================= */
  const handleGetLocation = async () => {
    try {
      const loc = await getLocation();

      console.log("get the loc",loc)

          const location = savedLocation || (await getLocation());
    if (!location) return notify("Location required", "error");

      setForm((prev) => ({
        ...prev,
        latitude: loc.latitude,
        longitude: loc.longitude,
        address: loc.address || prev.address,
        city: loc.city || prev.city,
        state: loc.state || prev.state,
        pincode: loc.pincode || prev.pincode
      }));

      notify("Location fetched successfully", "success");
    } catch {}
  };

  const handlePincodeChange = async (value) => {
  setForm((prev) => ({
    ...prev,
    pincode: value,
  }));

  if (!/^\d{6}$/.test(value)) {
    return;
  }

  try {
    const location = await getPincodeDetails(value);

    if (!location) {
      notify("Invalid or unavailable pincode", "error");

      setForm((prev) => ({
        ...prev,
        city: "",
        district: "",
        state: "",
      }));

      return;
    }

    setForm((prev) => ({
      ...prev,
      city: location.city,
      district: location.district,
      state: location.state,
    }));
  } catch (err) {
    notify("Unable to fetch pincode details", "error");
  }
};

  /* ================= SUBMIT ================= */
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (error) {
      notify(error, "error"); // ✅ Prevent submit if plan not assigned
      return;
    }

    if (!form.storeName || !form.businessType) {
      return notify("Please fill all required fields", "warning");
    }

    setSaving(true);

    const payload = {
      storeName: form.storeName,
      businessType: form.businessType,
      address: form.address,
      city: form.city,
      district: form.district,
      state: form.state,
      pincode: form.pincode,
      location:
        form.latitude && form.longitude
          ? { coordinates: [Number(form.longitude), Number(form.latitude)] }
          : undefined
    };

    try {
      const res = await postSingleMerchant(username, payload);

      if (res?.success) {
        notify(res?.message || "Merchant profile saved", "success");
     navigate('/')
      } else {
        notify(res?.message || "Save failed", "error");
      }
    } catch (err) {
      notify("Save failed, please try again", "error");
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <p className="p-4">Loading...</p>;

  return (
    <Main showRightPanel={false}>
      <div className="w-full">
        {/* BREADCRUMB */}
        <AppBreadcrumbs
          items={[
            { label: "Dashboard", to: "/" },
            { label: "Registration" },
            { label: "Agent Store" },
          ]}
        />

        <div className="border border-gray-100 shadow rounded-lg p-6">
          <h2 className="text-xl font-semibold mb-4">
            Merchant Business Details
          </h2>

          {/* ✅ Show error if plan not assigned */}
          {error && <Alert severity="error" className="mb-4">{error}</Alert>}

          <form
            onSubmit={handleSubmit}
            className="grid grid-cols-1 md:grid-cols-2 gap-4"
          >
            <Input label="Store Name" name="storeName" form={form} setForm={setForm} />
            <Select label="Business Type" name="businessType" form={form} setForm={setForm} />

            <Textarea label="Address" name="address" form={form} setForm={setForm} />
            <Input label="City" name="city" form={form} setForm={setForm} />
            <Input label="District" name="district" form={form} setForm={setForm} />
            <Input label="State" name="state" form={form} setForm={setForm} />
            {/* <Input label="Pincode" name="pincode" form={form} setForm={setForm} /> */}

<Input
  label="Pincode"
  name="pincode"
  form={form}
  setForm={setForm}
  onChange={handlePincodeChange}
/>

            <Input label="Latitude" name="latitude" form={form} setForm={setForm} />
            <Input label="Longitude" name="longitude" form={form} setForm={setForm} />

            {/* LOCATION BUTTON */}
            <div className="col-span-full">
              <button
                type="button"
                onClick={handleGetLocation}
                className="px-4 py-2 border rounded"
              >
                📍 Fetch Current Location
              </button>
            </div>

            {/* SUBMIT */}
            <div className="col-span-full flex justify-end">
              <button
                type="submit"
                // disabled={saving || !!error} // Disable submit if saving or error
                className={`px-6 py-2 rounded text-white transition-colors duration-200 
                  ${saving || !!error ? "bg-gray-400 cursor-not-allowed" : "bg-black hover:bg-gray-800"}`}
              >
                {saving ? "Saving..." : "Save & Continue"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </Main>
  );
};

/* ================= INPUT COMPONENTS ================= */
// const Input = ({ label, name, form, setForm }) => (
//   <div>
//     <label className="text-sm font-semibold">{label}</label>
//     <input
//       className="w-full border p-2 rounded"
//       value={form[name]}
//       onChange={(e) => setForm({ ...form, [name]: e.target.value })}
//     />
//   </div>
// );

const Input = ({ label, name, form, setForm, onChange }) => (
  <div>
    <label className="text-sm font-semibold">{label}</label>

    <input
      className="w-full border p-2 rounded"
      value={form[name]}
      maxLength={name === "pincode" ? 6 : undefined}
      inputMode={name === "pincode" ? "numeric" : undefined}
      onChange={(e) => {
        const value =
          name === "pincode"
            ? e.target.value.replace(/\D/g, "")
            : e.target.value;

        if (onChange) {
          onChange(value);
        } else {
          setForm((prev) => ({
            ...prev,
            [name]: value,
          }));
        }
      }}
    />
  </div>
);

const Textarea = ({ label, name, form, setForm }) => (
  <div className="md:col-span-2">
    <label className="text-sm font-semibold">{label}</label>
    <textarea
      className="w-full border p-2 rounded"
      rows={3}
      value={form[name]}
      onChange={(e) => setForm({ ...form, [name]: e.target.value })}
    />
  </div>
);

const Select = ({ label, name, form, setForm }) => (
  <div>
    <label className="text-sm font-semibold">{label}</label>
    <select
      className="w-full border p-2 rounded"
      value={form[name]}
      onChange={(e) => setForm({ ...form, [name]: e.target.value })}
    >
      <option value="">Select</option>
      <option>Retail Shop</option>
      <option>Mobile Shop</option>
      <option>CSC</option>
      <option>Kirna Store</option>
      <option>Online Business</option>
      <option>Other</option>
    </select>
  </div>
);

export default MerchantBusiness;
